export const formatPercent = (decimal: number | null | undefined, precision: number = 0): string => (decimal ? `${(decimal * 100).toFixed(precision)}%` : "-");
